export default "__VITE_ASSET__6a371731__"